import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-fe533098")

_pushScopeId("data-v-fe533098")
const _hoisted_1 = { class: "dec-nav" }
const _hoisted_2 = { ref: "navContent" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("ul", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.navs, (item) => {
        return (_openBlock(), _createBlock("li", {
          class: [_ctx.active === item.key ? 'active' : '', 'tab'],
          style: { width: _ctx.resetWidth ? _ctx.resetWidth + 'px' : ''},
          onClick: ($event: any) => (_ctx.choose(item)),
          key: item
        }, _toDisplayString(item.label), 15, ["onClick"]))
      }), 128))
    ], 512),
    _createVNode("li", {
      style: {width:'calc(100% - ' + _ctx.contentWidth+'px)'}
    }, null, 4)
  ]))
})